import { useMutation } from '@tanstack/react-query';
import { mintLlmCondomInstall } from '../services/api/llmCondom';

export function useLlmCondomToken() {
  return useMutation({
    mutationFn: (hostname?: string) => mintLlmCondomInstall(hostname),
  });
}
